/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_NoteInputs */

const en_gc_resources_compare_note = /** @type {(inputs: Gc_Resources_Compare_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the official sources for current capabilities. Test important files before switching.`)
};

const zh_gc_resources_compare_note = /** @type {(inputs: Gc_Resources_Compare_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新功能请以官方资料为准。更换工具前请先测试重要文件。`)
};

/**
* | output |
* | --- |
* | "Check the official sources for current capabilities. Test important files before switching." |
*
* @param {Gc_Resources_Compare_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_note = /** @type {((inputs?: Gc_Resources_Compare_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_note(inputs)
	return zh_gc_resources_compare_note(inputs)
});
export { gc_resources_compare_note as "gc.resources.compare.note" }